import { useTenantContext } from '@trashlab/sitesapp/src/contexts/use-tenant-context';
import { trpcPricingListSkusOpen } from '@trashlab/api/src/generated/hooks';
import { RedebinsDumpsterCard } from '../dumpster-rentals/dumpster-card';
import { Link } from '@trashlab/sitesapp/src/components/shared/link';
import { PageSEO } from '@trashlab/sitesapp/src/templates/redebins/components/shared/page-seo';

export const DumpsterSizesCards = () => {
  const { website } = useTenantContext();
  const tenantId = website?.organization?.id;

  const { data: skus, isLoading } = trpcPricingListSkusOpen.useQuery(
    {
      tenantId: tenantId ?? '',
      onlineOrderEnabled: true,
      status: 'ACTIVE',
      defaultOnly: true,
    },
    {
      enabled: !!tenantId,
    },
  );

  if (isLoading) {
    return (
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="flex justify-center items-center min-h-[200px]">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#E31837]" />
          </div>
        </div>
      </section>
    );
  }

  if (!skus || skus.length === 0) {
    return (
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">
            No Dumpsters Available
          </h2>
          <p className="text-gray-600 mb-6">Please contact us for availability.</p>
          <Link
            href="/contact"
            className="inline-block bg-[#E31837] hover:bg-[#c41530] text-white font-bold py-3 px-6 rounded transition-colors"
          >
            Contact Us
          </Link>
        </div>
      </section>
    );
  }

  // Sort by cubic yardage (larger first)
  const sortedSkus = [...skus].sort((a, b) => {
    const aYardsRaw = a.product?.cubicYardage;
    const bYardsRaw = b.product?.cubicYardage;

    const aYards =
      typeof aYardsRaw === 'string'
        ? parseInt(aYardsRaw.replace(/\D/g, ''), 10) || 0
        : Number(aYardsRaw) || 0;

    const bYards =
      typeof bYardsRaw === 'string'
        ? parseInt(bYardsRaw.replace(/\D/g, ''), 10) || 0
        : Number(bYardsRaw) || 0;

    return bYards - aYards;
  });

  return (
    <>
      <PageSEO pathname="/dumpster-sizes" />
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          {/* Section Header */}
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              <em>Choose Your RED-E-BIN</em>
            </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Select the perfect dumpster size for your project. Our compact
            dumpsters are designed to fit in your driveway without damaging your
            property.
          </p>
        </div>

        {/* Dumpster Grid */}
        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {sortedSkus.map((sku) => (
            <RedebinsDumpsterCard key={sku.id} sku={sku} />
          ))}
        </div>

          {/* How We Measure Up Link */}
          <div className="mt-12 text-center">
            <Link
              href="/how-we-measure-up"
              className="text-[#E31837] hover:underline font-medium text-lg"
            >
              See how we measure up to the competition →
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};
